export default "__VITE_ASSET__Csw$RIo1__"